const KEY = 'kit.token';

/** The device's bearer token; kept in localStorage so the app opens signed in offline. */
export const tokenStorage = {
  get(): string | null {
    return localStorage.getItem(KEY);
  },
  set(token: string | null): void {
    if (token) localStorage.setItem(KEY, token);
    else localStorage.removeItem(KEY);
  },
};
